import { render, staticRenderFns } from "./ChoosePlan.vue?vue&type=template&id=2b6558f0&scoped=true&"
import script from "./ChoosePlan.vue?vue&type=script&lang=js&"
export * from "./ChoosePlan.vue?vue&type=script&lang=js&"
import style0 from "./ChoosePlan.vue?vue&type=style&index=0&id=2b6558f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6558f0",
  null
  
)

export default component.exports